<template>
    <Wrapper>
        <div class="flex-fill">
            <div class="row">
                <div class="col-xl-4 col-md-6 pb-3">
                    <div class="card d-block p-0 h-100 shadow-sm wow zoomIn">
                        <div class="row h-100 no-gutters rounded flex-nowrap">
                            <div class="col-auto bg-info rounded-left">&nbsp;</div>
                            <div class="col p-3 py-4 text-info">
                                <h6 class="text-truncate text-uppercase">Sales</h6>
                                <h3>53</h3>
                            </div>
                            <div class="col-auto d-flex rounded-right">
                                <h1 class="mb-0 mx-auto align-self-center"><a href="/" class="nav-link text-info pb-0" title="View details">
                                    <span class="d-inline-block lnr lnr-cart"></span></a>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-md-6 pb-3">
                    <div class="card d-block h-100 shadow-sm wow zoomIn">
                        <div class="row h-100 no-gutters rounded flex-nowrap">
                            <div class="col-auto bg-primary rounded-left">&nbsp;</div>
                            <div class="col p-3 py-4 text-primary">
                                <h6 class="text-truncate text-uppercase">Growth</h6>
                                <h3 class="text-nowrap">19%</h3>
                            </div>
                            <div class="col-auto d-flex rounded-right">
                                <h1 class="mb-0 mx-auto align-self-center">
                                    <a href="/" class="nav-link pb-0 text-primary" title="View details">
                                        <span class="d-inline-block lnr lnr-rocket"></span>
                                    </a>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 pb-3 order-xl-0 order-md-1">
                    <div class="card d-block p-0 h-100 shadow-sm wow zoomIn">
                        <div class="row h-100 no-gutters rounded flex-nowrap">
                            <div class="col-auto bg-success rounded-left">&nbsp;</div>
                            <div class="col p-3 py-4 text-success">
                                <h6 class="text-truncate text-uppercase">Calls</h6>
                                <h3 class="text-nowrap">210</h3>
                            </div>
                            <div class="col-auto d-flex text-success">
                                <h1 class="mb-0 mx-auto align-self-center">
                                <a href="/" class="nav-link text-success pb-0" title="View details"><span class="d-inline-block lnr lnr-phone"></span></a>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-md-6 py-3 wow zoomIn">
                    <div class="card h-100 shadow-sm">
                        <div class="card-body p-xl-3 p-2 d-flex flex-column">
                            <h4 class="font-weight-light mb-3">Orders</h4>
                            <div class="my-auto p-1 py-2">
                                <LineChart :data="lineChartData" :options="lineChartOptions" height="220" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-md-6 py-3">
                    <div class="card h-100 shadow-sm">
                        <div class="card-body p-xl-3 p-2 d-flex flex-column">
                            <h4 class="font-weight-light mb-3">Revenue</h4>
                            <div class="my-auto p-1 py-2">
                                <LineChart :data="lineChartData2" :options="lineChartOptions" height="220" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 order-xl-0 order-md-1 py-3 wow zoomIn">
                    <div class="card h-100 shadow-sm">
                        <div class="card-body p-xl-3 p-2 d-flex flex-column">
                            <h4 class="font-weight-light mb-3">Customers</h4>
                            <div class="my-auto p-1 py-2">
                                <LineChart :data="lineChartData3" :options="lineChartOptions" height="220" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-4 col-md-6 py-3 wow zoomIn">
                    <div class="card shadow-sm rounded-lg h-100">
                        <div class="card-header bg-transparent border-bottom-0">
                            <div class="row align-items-center">
                                <div class="col-sm">
                                    <h4 class="font-weight-light mb-0">Last Order</h4>
                                </div>
                                <div class="col-sm-auto ml-auto">
                                    <h4 class="mb-0 mt-1"><span class="icons icon-paypal"></span></h4>
                                </div>
                            </div>
                        </div>
                        <div class="card rounded-lg border-0 mt-3">
                            <div class="row align-items-center">
                                <div class="col">
                                    <div class="card-body py-2 text-truncate">
                                        <img src="assets/profile_2.png" alt="profile pic" class="rounded-circle bg-light float-right avatar">
                                        <h4 class="mb-0 text-info">Austin Farnum</h4>
                                        <p class="mt-1">Fort Knox, TX 28192</p>
                                        <h3 class="mb-0">$197.55</h3>
                                        <p>Total items: 3</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-md-6 py-3">
                    <SliderContent containerClasses="card shadow-sm rounded-lg h-100" 
                        carouselId="contentSlider" 
                        header="Products" 
                        headingClasses="h4 text-primary"
                        :items="contentItems" 
                        contentClasses="text-left pb-3" />
                </div>
                <div class="col-xl-4 py-3 wow zoomIn">
                    <SliderContent containerClasses="card shadow-sm rounded-lg h-100" 
                        carouselId="contentSlider2" 
                        carouselInterval="3000"
                        header="Goals" 
                        :items="contentItems2" 
                        contentClasses="text-left pb-3" headingClasses="h5 text-uppercase" 
                        carouselButtonClasses="btn btn-outline-success btn-sm ml-2" 
                        buttonClasses="btn btn-outline-secondary mt-2" />
                </div>
            </div>
        </div>
    </Wrapper>
</template>
<script>
import { Wrapper, LineChart, SliderContent } from '../../components';

export default {
    components: {
        Wrapper,
        LineChart,
        SliderContent
    },
    data() {
        return {
            lineChartOptions: {
              responsive: true,
              maintainAspectRatio: false,
              legend: {display:false},
              title: {display:false},
              elements: {
                line: {
                    fill: false
                },
                point: {
                    radius: 1
                }
              },
              scales: {
                yAxes: [{
                  display: false,
                  ticks: {
                    beginAtZero: false,
                    stepValue: 5
                  }
                }]
              }
            },
            lineChartData: {
              labels: [
                "J","F","M","A","M","J","J","A","S","O"
              ],
              datasets: [
                {
                  label: "",
                  data: []
                },
                {
                  label: "",
                  data: []
                },
                {
                  label: "",
                  data: []
                },
                {
                  label: "Sales",
                  data: [209,211,214,213,216,215,218,217,216,219]
                }]
            },
            lineChartData2: {
              labels: [
                "J","F","M","A","M","J","J","A","S","O"
              ],
              datasets: [
                {
                  label: "",
                  data: []
                },
                {
                  label: "",
                  data: []
                },
                {
                  label: "Revenue",
                  data: [209,210,212,211,213,212,214,213,216,214],
                  fill: true
                }]
            },
            lineChartData3: {
              labels: [
                "J","F","M","A","M","J","J","A","S","O"
              ],
              datasets: [
                {
                  label: "",
                  data: []
                },
                {
                  label: "",
                  data: []
                },
                {
                  label: "",
                  data: []
                },
                {
                  label: "",
                  data: []
                },
                {
                  label: "Customers",
                  data: [208,213,212,211,213,212,214,213,214,211]
                }]
            },
            contentItems: [
                {heading:"Bayside 22 Offshore", content:"Flip the bottom cushion of the console-front seat to reveal an insulated cooler. You will also find a freshwater fill hidden under the cushion.", url:"./"},
                {heading:"Millway 211 CC", content:"At the center of the bow you will find a lid with some additional in-floor storage with drain. Common uses for this include nets.", url:"./"}
            ],
            contentItems2: [
                {heading:"Marketing", content:'<p>Results based on last campaign.</p><div class="progress mt-3"><div role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" class="progress-bar bg-success w-75 h-50 my-auto"></div></div><small class="text-uppercase">Since Jan 2019</small>', url:"./"},
                {heading:"Operations", content:'<p>Results based on new hires and training.</p><div class="progress mt-3"><div role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" class="progress-bar bg-success w-50 h-50 my-auto"></div></div><small class="text-uppercase">Since Jan 2019</small>', url:"./"}
            ]
        };
    }
};
</script>
